import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import axios from 'axios'
import routes from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/main.css'  // 引入 TailwindCSS
import certificationManager from './utils/certificationManager.js'
import { setupRouterGuards } from './router/guards.js'
import VueSignaturePad from 'vue-signature-pad'
import vueEsign from 'vue3-esign'

// 生产环境关闭所有 console 调试输出（不影响业务功能）
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
  const noop = () => {}
  const methods = ['log', 'info', 'warn', 'error', 'debug']
  methods.forEach((m) => {
    try {
      if (typeof console !== 'undefined' && typeof console[m] === 'function') {
        console[m] = noop
      }
    } catch (_) {
      // ignore
    }
  })
}

const app = createApp(App)
dayjs.locale('zh-cn')

// 配置路由
// 兼容多种导出形态，确保传入的是路由数组
const normalizedRoutes = Array.isArray(routes)
  ? routes
  : (routes && routes.routes)
    ? routes.routes
    : (routes && routes.default && Array.isArray(routes.default))
      ? routes.default
      : []


const vueRouter = createRouter({
  history: createWebHistory('/'),
  routes: normalizedRoutes,
  scrollBehavior() {
    // 每次路由切换回到页面顶部，避免顶部被遮挡
    return { left: 0, top: 0 }
  }
})


// 若缺少 /lossless/index，则在运行时补注册，避免无法访问
try {
  const hasLossless = vueRouter.getRoutes().some(r => r.path === '/lossless/index')
  if (!hasLossless) {
    vueRouter.addRoute({
      path: '/lossless/index',
      name: '无损检测-临时',
      component: () => import('./pages/lossless/index.vue')
    })
  }
} catch (e) {
  // ignore
}

// 设置路由守卫
setupRouterGuards(vueRouter)

app.use(vueRouter)
app.use(ElementPlus, { locale: zhCn })
app.use(certificationManager)
app.use(VueSignaturePad)
app.use(vueEsign)
app.config.globalProperties.$axios = axios

// 统一的全局 toast，供 this.$toast.warning/error/success 使用
app.config.globalProperties.$toast = {
  warning(message) { ElMessage.warning(message) },
  error(message) { ElMessage.error(message) },
  success(message) { ElMessage.success(message) },
  info(message) { ElMessage.info(message) }
}

// 应用启动时清理已废弃的本地 user_id，避免以旧查新
try {
  if (localStorage.getItem('user_id')) {
    localStorage.removeItem('user_id')
  }
} catch (e) {
  // ignore
}

app.mount('#app')
